/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'

export const inviteAnswerRequestV4Schema = z.object({
  inviteId: z
    .string()
    .nullish()
    .describe(
      'Coded id of the invitation being answered — the referenceId carried by the AcceptOrgInvite event.'
    )
    .meta({ examples: ['kJ8v2Qm7xR1a'] }),
})
